// src/ui/loader.js
import { el } from '../lib/dom.js';
/** Loader bonito (spinner verde) para carregamento de tabelas/telas. */
export function loader(texto) {
  return el('div', { class: 'loader' }, [
    el('div', { class: 'loader__spin' }),
    el('span', { class: 'loader__txt', text: texto || 'Carregando…' }),
  ]);
}